import React from 'react';

import ItemsProviderSynchronizer from '@common/react/components/Core/AdvancedItemsProvider/ItemsProviderSynchronizer';

import { AppointmentTypesProvider } from '@app/components/UI/AppointmentType/AppointmentTypesProvider';

export const AppointmentTypesSynchronizer: React.FC = () => {
	return <AppointmentTypesProvider>
		<ItemsProviderSynchronizer
			objectType="AppointmentTypeRedux"
		/>
	</AppointmentTypesProvider>;
};
